import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ButtonDark, InputWrapper } from "../StyledComponents/AppStyles";
import {
  EyeIcon,
  LoginContainer,
  LoginForm,
} from "../StyledComponents/LoginStyles";

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [userIdInput, setUserIdInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Password login is not available in this demo.");
  };

  return (
    <LoginContainer>
      <LoginForm onSubmit={handleSubmit}>
        <h2>Account Log In</h2>
        <InputWrapper>
          <label htmlFor="userID">User ID</label>
          <input
            type="text"
            id="user-id"
            name="userID"
            onChange={(e) => setUserIdInput(e.target.value)}
          />
        </InputWrapper>
        <InputWrapper>
          <label htmlFor="password">Password</label>
          <span>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              onChange={(e) => setPasswordInput(e.target.value)}
            />
            <EyeIcon
              style={showPassword ? { color: "#2A5D8D" } : {}}
              onClick={() => setShowPassword(!showPassword)}
            />
          </span>
        </InputWrapper>
        <div>
          <span>
            <input type="checkbox" id="remember" name="remember" />
            <label htmlFor="remember">Remember me</label>
          </span>
          <ButtonDark
            disabled={userIdInput && passwordInput ? false : true}
            type="submit"
          >
            Log in
          </ButtonDark>
        </div>
        <div>
          <p>
            Don't have an account?{" "}
            <u onClick={() => navigate("/create-account")}>
              Click here to create one.
            </u>
          </p>
          <u onClick={() => navigate("/login/credentials")}>
            Log in with a credential
          </u>
        </div>
      </LoginForm>
    </LoginContainer>
  );
}
